import * as Sentry from '@sentry/react';
export var Log = function (breadCrumb) {
    if (!Object.values(breadCrumb).length) {
        return;
    }
    Sentry.addBreadcrumb(breadCrumb);
};
